module.exports = __webpack_public_path__ + "media/images/front/pc/institution-search/face-e642f799b44459d2e3dbbaacdc6eed5f.svg";